import { useEffect } from "react";
import { useLocation } from "react-router-dom";

let internalHistory = [];

const useInternalHistory = () => {
  const location = useLocation();

  useEffect(() => {
    // Only push if different from last entry
    if (internalHistory[internalHistory.length - 1] !== location.pathname) {
      internalHistory.push(location.pathname);
    }
  }, [location]);

  return internalHistory;
};

export default useInternalHistory;
